module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    staticClass: "center",
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "wrapper",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('skirental.measure-foot-text'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "border"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/fot-mata.svg"
    }
  })]), _vm._v(" "), (_vm.showDinText) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('skirental.measure-foot-din'))
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40a0254e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkiRentalFoot.vue
// module id = 955
// module chunks = 0